<script lang="ts" setup>
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import PickUpPointNotification from '~/components/modal-windows/shipping/PickUpPointNotification.vue'
import OrderShippingType from '~/enums/order-shipping-type'
import Page from '~/enums/page'
import { useCartStore } from '~/store/cart'

const model = defineModel<boolean>()

const props = defineProps<{
  declaredValueInKopecks: number
}>()

const cartStore = useCartStore()

const scriptElement = ref<HTMLScriptElement | null>(null)

const style = computed(() => {
  const { RussianPostCourier, RussianPostPickUpPoint } = OrderShippingType

  switch (cartStore.orderShippingType) {
    case RussianPostPickUpPoint:
      return { height: '500px' }
    case RussianPostCourier:
      return { height: '740px' }
    default:
      return {}
  }
})
const title = computed(() => {
  const { RussianPostCourier, RussianPostPickUpPoint } = OrderShippingType

  switch (cartStore.orderShippingType) {
    case RussianPostPickUpPoint:
      return 'Выбор пункта выдачи заказов\xA0— Почта России'
    case RussianPostCourier:
      return 'Выбор адреса доставки\xA0— Почта России'
    default:
      return null
  }
})

function cbRussianPost (data: any): void {
  console.log(data)

  const { RussianPostCourier, RussianPostPickUpPoint } = OrderShippingType
  const { addressTo, areaTo, cashOfDelivery, cityTo, indexTo, mailType, regionTo } = data

  cartStore.shippingCostInKopecks = cashOfDelivery || null

  const shippingData = {
    address: [indexTo, regionTo || areaTo, cityTo, addressTo].filter((x: any): boolean => x && x !== 'null').join(', '),
    area: areaTo || null,
    details: addressTo || null,
    mailType: mailType || null,
    place: cityTo || null,
    postcode: indexTo || null,
    region: regionTo || null
  }

  switch (cartStore.orderShippingType) {
    case RussianPostPickUpPoint: {
      const { boxSize, pvzType } = data
      cartStore.shippingData = { ...shippingData, boxSize: boxSize || null, type: pvzType || null }
      break
    }
    case RussianPostCourier: {
      const { comment } = data
      cartStore.shippingData = { ...shippingData, comment: comment || null }
      break
    }
    default:
      break
  }

  close()
}

function close (): void {
  model.value = false
}

function closed (): void {
  (scriptElement.value as HTMLScriptElement).parentNode?.removeChild(scriptElement.value as HTMLScriptElement)
}

function opened (): void {
  const { declaredValueInKopecks } = props
  const { RussianPostCourier, RussianPostPickUpPoint } = OrderShippingType
  const params = {
    callbackFunction: cbRussianPost,
    containerId: 'russian-post-widget',
    sumoc: declaredValueInKopecks,
    weight: cartStore.weightInGrams
  }

  const _scriptElement = document.createElement('script')
  _scriptElement.async = true

  switch (cartStore.orderShippingType) {
    case RussianPostPickUpPoint:
      _scriptElement.onload = (): void => {
        (window as any).ecomStartWidget({ id: 25373, ...params })
      }
      _scriptElement.src = 'https://widget.pochta.ru/map/widget/widget.js'
      break
    case RussianPostCourier:
      _scriptElement.onload = (): void => {
        (window as any).courierStartWidget({ id: 25374, ...params })
      }
      _scriptElement.src = 'https://widget.pochta.ru/courier/widget/widget.js'
      break
    default:
      break
  }

  scriptElement.value = _scriptElement
  document.getElementsByTagName('head')[0].appendChild(_scriptElement)
}
</script>

<template>
  <CustomModalWindow v-model="model" size="large" @closed="closed" @opened="opened">
    <template v-if="title" #title>
      {{ title }}
    </template>

    <Notification class="mb-6" is-small status="info">
      Внимание! Срок доставки Почтой России указан со&nbsp;дня приёма посылки в&nbsp;сортировочном центре, в&nbsp;связи с&nbsp;чем фактический срок может быть увеличен. Точную информацию о&nbsp;сроках можно получить в&nbsp;клиентской службе Почты России по&nbsp;номеру: 88001000000.<br><br>
      Для экспресс-доставки по&nbsp;Москве выбирайте способ Dostavista.<br><br>
      <a :href="Page.Delivery" target="_blank">Подробнее об&nbsp;условиях доставки</a>.
    </Notification>

    <Notification class="mb-6" is-small status="warning">
      Обратите внимание: SMS больше не&nbsp;отправляются. Все обновления о&nbsp;статусе отправлений теперь можно получать через push-уведомления в&nbsp;мобильном приложении Почты России. Установите его и&nbsp;включите уведомления, чтобы не&nbsp;пропустить важную информацию.
    </Notification>

    <PickUpPointNotification
      v-if="cartStore.orderShippingType === OrderShippingType.RussianPostPickUpPoint"
      class="mb-6"
    />
    <Notification
      v-else-if="cartStore.orderShippingType === OrderShippingType.RussianPostCourier"
      class="mb-6"
      is-small
      status="info"
    >
      Пожалуйста, указывайте адрес доставки с&nbsp;точностью до&nbsp;квартиры.
    </Notification>

    <div id="russian-post-widget" :style="style" />

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
